

export const mapResponse =  response => (response.data);
